import React, { useCallback, useState } from 'react'
import classnames from 'classnames'

import { Food } from '../../../core/foods'
import { foodTableContent } from './foods-content'
import { ReactSortable } from 'react-sortablejs'
import { Link } from 'react-router-dom'
import styles from '../../styles/modules/table.module.scss'
import foodTableStyles from '../../styles/modules/foods/food-table.module.scss'

interface Props {
  foods: Food[]
  changeFoodsIndex: (ids: number[]) => void
}

const FoodTable: React.FC<Props> = props => {
  const [localFoods, setLocalFoods] = useState(props.foods)

  // propsが変更されたら内部stateも更新
  React.useEffect(() => {
    setLocalFoods(props.foods)
  }, [props.foods])

  const handleOnSort = useCallback(() => {
    // 実際にドラッグ&ドロップが完了した時のみAPIを呼び出し
    props.changeFoodsIndex(localFoods.map(food => food.id))
  }, [props, localFoods])

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={styles.container}>
        <thead>
          <tr className={foodTableStyles.row}>
            {foodTableContent.map((item, index) => (
              <th key={index} className={styles.cell}>
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <ReactSortable
          tag="tbody"
          list={localFoods}
          setList={setLocalFoods}
          handle=".handle"
          onSort={handleOnSort}
        >
          {localFoods.map((food, index) => (
            <tr
              className={classnames(styles.row, {
                [foodTableStyles.oddRow]: index % 2 === 1,
              })}
              key={food.id}
            >
              <td className={`${foodTableStyles.cell} handle`}>
                <div className={foodTableStyles.orderIcon}>
                  <span />
                  <span />
                  <span />
                </div>
              </td>
              <td className={styles.cell}>{food.id}</td>
              <td className={styles.cell}>{index + 1}</td>
              <td className={styles.cell}>
                <Link to={`/foods/${food.id}`}>{food.name}</Link>
              </td>
              <td className={styles.cell}>{food.categoryDisplayName || '-'}</td>
              <td className={foodTableStyles.imgCell}>
                {food.thumbnailImageURL ? (
                  <img
                    alt="food"
                    src={food.thumbnailImageURL}
                    className={foodTableStyles.image}
                  />
                ) : (
                  <div className={foodTableStyles.noImagePlaceholder}>
                    未設定
                  </div>
                )}
              </td>
            </tr>
          ))}
        </ReactSortable>
      </table>
    </div>
  )
}

export default FoodTable
